import {z} from "zod/v4-mini"
import {graphNode} from "@cm/graph-v3"
import {registerTemplateGraphNode} from "#template/template-node/register"
import {meshGeometryAttributeLikeMarker} from "#template/nodes/geometry-graph/attribute/attribute-node"
import {MeshGeometryUnaryMathOperator} from "#template/nodes/geometry-graph/attribute/unary-math-operator/mesh-geometry-unary-math-operator"
import {MeshGeometryBinaryMathOperator} from "#template/nodes/geometry-graph/attribute/binary-math-operator/mesh-geometry-binary-math-operator"

import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

import type {MeshGeometryAttributeLikeNode} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {GeometryMathOperatorParameters} from "#template/nodes/geometry-graph/attribute/math-operator/geometry-math-operator-node"
import {GeometryMathOperatorNode} from "#template/nodes/geometry-graph/attribute/math-operator/geometry-math-operator-node"

export type MeshGeometryGeometryMathOperatorParameters = GeometryMathOperatorParameters<MeshGeometryUnaryMathOperator | MeshGeometryBinaryMathOperator>

const definition: TemplateNodeDefinition<MeshGeometryGeometryMathOperatorParameters> = {
    nodeClass: "MeshGeometryMathOperator",
    validation: {
        parameters: z.object({
            name: z.string(),
            operator: z.union([graphNode(MeshGeometryUnaryMathOperator), graphNode(MeshGeometryBinaryMathOperator)]),
        }),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class MeshGeometryMathOperator
    extends GeometryMathOperatorNode<2, MeshGeometryUnaryMathOperator | MeshGeometryBinaryMathOperator, MeshGeometryGeometryMathOperatorParameters>
    implements MeshGeometryAttributeLikeNode
{
    get [meshGeometryAttributeLikeMarker]() {
        return true as const
    }

    public override get definition() {
        return definition
    }
}
